import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex items-center q-my-sm" }
const _hoisted_2 = { class: "text-primary text-subtitle2 q-my-none" }
const _hoisted_3 = { class: "flex justify-center q-my-sm" }
const _hoisted_4 = { class: "unstyled q-pa-none" }
const _hoisted_5 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_post_count_chip = _resolveComponent("post-count-chip")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_add_client_btn = _resolveComponent("add-client-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_user_client_sort_group = _resolveComponent("user-client-sort-group")!
  const _component_async_items_loader = _resolveComponent("async-items-loader")!
  const _component_user_client_item = _resolveComponent("user-client-item")!
  const _component_view_all_btn = _resolveComponent("view-all-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
        _createVNode(_component_post_count_chip, {
          count: _ctx.totalUnreviewed,
          type: "unreviewed",
          size: "sm"
        }, null, 8, ["count"]),
        _createVNode(_component_post_count_chip, {
          count: _ctx.totalEscalated,
          type: "escalated",
          size: "sm"
        }, null, 8, ["count"])
      ]),
      _createVNode(_component_q_space),
      _createVNode(_component_add_client_btn, {
        star: _ctx.starred,
        title: "Add new client",
        round: "",
        flat: ""
      }, null, 8, ["star"])
    ]),
    _createVNode(_component_q_input, {
      modelValue: _ctx.searchQuery,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
      placeholder: "Name, email or file ref no.",
      autocomplete: "no",
      dense: "",
      filled: ""
    }, {
      prepend: _withCtx(() => [
        _createVNode(_component_q_icon, {
          name: "fa fa-search",
          size: "xs",
          color: "primary"
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_user_client_sort_group, {
        "order-by": _ctx.orderBy,
        order: _ctx.order,
        flat: "",
        onOrderByChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.orderBy = $event)),
        onOrderChanged: _cache[2] || (_cache[2] = ($event: any) => (_ctx.order = $event))
      }, null, 8, ["order-by", "order"])
    ]),
    _createVNode(_component_async_items_loader, {
      task: _ctx.task,
      "num-items": _ctx.userClients.length,
      class: "q-mt-md"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" No clients found. ")
      ]),
      _: 1
    }, 8, ["task", "num-items"]),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleUserClients, (userClient) => {
        return (_openBlock(), _createBlock(_component_user_client_item, {
          key: userClient.id,
          "user-client": userClient,
          class: "animated fadeIn"
        }, null, 8, ["user-client"]))
      }), 128))
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _createVNode(_component_view_all_btn, {
        total: _ctx.userClients.length,
        modelValue: _ctx.showAll,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showAll) = $event))
      }, null, 8, ["total", "modelValue"])
    ], 512), [
      [_vShow, _ctx.canShowMore || _ctx.showAll]
    ])
  ]))
}